import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import { useDispatcher } from '../../../store.decorator';

import { TranslationKeyMap } from './ca-analysis-dialog.i18n';
import { CaAnalysisDialogService } from './ca-analysis-dialog.service';
import { minMax } from './state/min-max.action';

@Component({
    selector: 'cmps-ca-analysis-dialog',
    templateUrl: './ca-analysis-dialog.component.html',
    host: {
        class: 'cmps-ca-analysis-dialog',
        '[class.cmps-ca-analysis-dialog--minimized]':
            '_service.state?.minimized',
    },
})
export class CaAnalysisDialogComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    /** @private */
    _i18n = TranslationKeyMap;

    @ViewChild('hudBtnTpl') private readonly _hudBtnTpl: TemplateRef<any>;

    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            CaAnalysisDialogService,
            void
        >,
        /** @private */ readonly _service: CaAnalysisDialogService,
    ) {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        const buttons = [];
        // see meetingRequestContext?.evaluationEnabled
        if (
            this._service.callStatusService.callHandle?.streamTranscript ===
            true
        ) {
            buttons.push(this._hudBtnTpl);
        }
        this._service.callStatusService.buttons = buttons;
    }

    ngOnDestroy(): void {}

    /** @private **/
    _onMinMaxClick(): void {
        useDispatcher(
            this._service,
            minMax({ minimized: !(this._service.state?.minimized ?? false) }),
        );
    }

    /** @private */
    _onCloseClick(): void {
        this._dialogRef.close();
    }
}
